import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import SportsMatchesList from "../../components/SportsMatchesList";
import HorseFilteredMatches from "../Sports/Horse/HorseFilteredMatches";

const MultiMarkets = () => {
  const [pinnedEvents, setPinnedEvents] = useState([]);
  const [pinnedTrackNames, setPinnedTrackNames] = useState([]);

  useEffect(() => {
    const loadPinnedEvents = () => {
      setPinnedEvents(JSON.parse(localStorage.getItem("pinnedEvents") || "[]"));
    };
    loadPinnedEvents();
    window.addEventListener("pinnedEventsUpdated", loadPinnedEvents);
    return () =>
      window.removeEventListener("pinnedEventsUpdated", loadPinnedEvents);
  }, []);

  useEffect(() => {
    const loadPinnedTracks = () => {
      setPinnedTrackNames(
        JSON.parse(localStorage.getItem("pinnedTrackName") || "[]")
      );
    };
    loadPinnedTracks();
    window.addEventListener("pinnedTrackNameUpdated", loadPinnedTracks);
    return () =>
      window.removeEventListener("pinnedTrackNameUpdated", loadPinnedTracks);
  }, []);

  const horseMatches = useSelector((state) => state?.horse?.horseRaceList);
  const filteredHorseMatches =
    horseMatches
      ?.map((match) => ({
        ...match,
        children: match.children?.filter((child) =>
          pinnedTrackNames.includes(child.ename)
        ),
      }))
      .filter((match) => match.children?.length > 0) || [];

  const cricketMatches = useSelector(
    (state) => state.matches.cricket.matches.data
  );
  const tennisMatches = useSelector(
    (state) => state.matches.tennis.matches.data
  );
  const soccerMatches = useSelector(
    (state) => state.matches.soccer.matches.data
  );

  const allFilteredMatches = [
    ...(cricketMatches || []).filter((e) => pinnedEvents.includes(e.eventId)),
    ...(tennisMatches || []).filter((e) => pinnedEvents.includes(e.eventId)),
    ...(soccerMatches || []).filter((e) => pinnedEvents.includes(e.eventId)),
  ];

  const hasMatches =
    allFilteredMatches.length > 0 || filteredHorseMatches.length > 0;

  return (
    <div>
      {hasMatches && (
        <div className="!bg-[white] w-full">
          <div
            className="w-full p-1"
            style={{
              background: "linear-gradient(-180deg, #2E4B5E 0%, #243A48 82%)",
            }}
          >
            <h3 className="text-center font-bold text-[12px] text-[white]">
              Multi Markets
            </h3>
          </div>
        </div>
      )}

      {allFilteredMatches.length > 0 && (
        <SportsMatchesList matchesList={allFilteredMatches} />
      )}

      {filteredHorseMatches.length > 0 && (
        <HorseFilteredMatches
          data={filteredHorseMatches}
          activeTab="ALL"
          DisplayName={false}
        />
      )}

      {allFilteredMatches.length === 0 && filteredHorseMatches.length === 0 && (
        <div className="w-full p-3">
          <div className="rounded-lg bg-light-bg dark:bg-dark-bg border border-gray-500 w-full h-[140px] text-center flex justify-center items-center">
            <div className="flex justify-center items-center w-full">
              <div className="flex justify-center">
                <div className="w-12 h-12 flex items-center justify-center">
                  <svg
                    className="w-8 h-8 text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M3 3h4v4H3V3zm6 0h4v4H9V3zm6 0h4v4h-4V3zM3 9h4v4H3V9zm6 0h4v4H9V9zm6 0h4v4h-4V9zM3 15h4v4H3v-4zm6 0h4v4H9v-4zm6 0h4v4h-4v-4z" />
                  </svg>
                </div>
              </div>
              <div>
                <h2 className="text-gray-400 text-[5vw] font-medium mb-3 leading-relaxed">
                  There are currently no followed
                  <br /> multi markets.
                </h2>
                <hr />
                <p className="text-gray-400 font-medium text-[4vw]">
                  Please add some markets from events.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiMarkets;
